// Report rows in chart order (rule H-6): each group's subtotal row, then the groups beneath it, then its own accounts.
// The subtotals come from the server, each account counted once at every level; this only orders and indents them.

export type TreeRow<G, R> = { g: G; depth: number } | { r: R; depth: number };

export function treeRows<G extends { group: { id: string; parentId: string | null; depth: number } }, R>(groups: G[], rows: R[], typeOf: (r: R) => string): TreeRow<G, R>[] {
  const ids = new Set(groups.map((g) => g.group.id));
  const kids = new Map<string | null, G[]>();
  for (const g of groups) { const k = g.group.parentId && ids.has(g.group.parentId) ? g.group.parentId : null; (kids.get(k) ?? kids.set(k, []).get(k)!).push(g); }
  const out: TreeRow<G, R>[] = [];
  const placed = new Set<R>();
  const walk = (g: G) => {
    out.push({ g, depth: g.group.depth });
    for (const c of kids.get(g.group.id) ?? []) walk(c);
    for (const r of rows) if (typeOf(r) === g.group.id) { out.push({ r, depth: g.group.depth + 1 }); placed.add(r); }
  };
  for (const g of kids.get(null) ?? []) walk(g);
  // Anything not under a listed group (none expected) still shows, at the end.
  for (const r of rows) if (!placed.has(r)) out.push({ r, depth: 1 });
  return out;
}
